export const featureAbbr = "catalog"